import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { GetOrgDataForSeedDistribution, GetUserID } from "./Common";
import Select from "react-select";

const Home = () => {
  const [names, setNames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedName, setSelectedName] = useState("");
  const [traceCode, setTraceCode] = useState("");
  const [errors, setErrors] = useState({});

  const navigate = useNavigate();

  useEffect(() => {
    const fetchNames = async () => {
      try {
        const response = await GetOrgDataForSeedDistribution({});
        setNames(response?.data?.data || []);
      } catch (error) {
        console.error("Error fetching data:", error);
        setNames([]);
      } finally {
        setLoading(false);
      }
    };

    fetchNames();
  }, [GetOrgDataForSeedDistribution]);

  const options = names.map((item) => ({
    value: item.Org_Master_ID,
    label: item.Org_Name,
  }));

  const handleNext = async () => {
    const newErrors = {};
    if (!selectedName) newErrors.name = "Name is required";
    if (!traceCode.trim()) newErrors.traceCode = "Tracenet Code is required";
    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      const selectedOrg = names.find(
        (item) => item.Org_Master_ID === parseInt(selectedName)
      );

      if (!selectedOrg) {
        setErrors({ name: "Selected organization not found" });
        return;
      }

      try {
        const payload = {
          Mobile_Number: traceCode,
          Org_Code: selectedOrg.Org_Code,
        };

        const response = await GetUserID(payload);
        // console.log("API response data:", response.data);

        const userId = response?.data?.data?.user?.User_ID;

        if (!userId) {
          setErrors({ traceCode: "User ID not found in response" });
          return;
        }

        // ✅ Navigate directly without Swal
        navigate(`/signature-thumb/${selectedOrg.Org_Code}/${userId}`);
      } catch (err) {
        console.error("API Error:", err);
        setErrors({ traceCode: "User not found" });
      }
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-r from-green-100 via-white to-green-100 flex items-center justify-center p-4">
      <div className="bg-white shadow-2xl rounded-2xl p-8 w-full max-w-md space-y-6">
        <h1 className="text-3xl font-bold text-center text-green-700">
          Seed Distribution
        </h1>
        {/* Name Dropdown */}
        <div>
          <label
            htmlFor="name"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            ICS Name
          </label>
          <Select
            inputId="name"
            value={options.find((opt) => opt.value === selectedName) || null}
            onChange={(selectedOption) =>
              setSelectedName(selectedOption?.value || "")
            }
            options={options}
            isLoading={loading}
            placeholder="Select Name"
            classNamePrefix={
              errors.name ? "react-select-error" : "react-select"
            }
            styles={{
              control: (base, state) => ({
                ...base,
                borderRadius: "0.75rem",
                borderColor: errors.name ? "#f87171" : "#d1d5db", // red-500 or gray-300
                boxShadow: state.isFocused
                  ? `0 0 0 2px ${errors.name ? "#f87171" : "#4ade80"}` // red-400 or green-400
                  : undefined,
                "&:hover": {
                  borderColor: errors.name ? "#f87171" : "#4ade80",
                },
              }),
            }}
          />
          {errors.name && (
            <p className="text-red-600 text-sm mt-1">{errors.name}</p>
          )}
        </div>
        {/* Trace Code Input */}
        <div>
          <label
            htmlFor="traceCode"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Tracenet Code
          </label>
          <input
            type="text"
            id="traceCode"
            value={traceCode}
            onChange={(e) => setTraceCode(e.target.value)}
            placeholder="Enter trace code"
            className={`w-full border rounded-xl px-4 py-2 text-gray-700 focus:outline-none focus:ring-2 ${
              errors.traceCode
                ? "border-red-500 focus:ring-red-400"
                : "border-gray-300 focus:ring-green-400"
            }`}
          />
          {errors.traceCode && (
            <p className="text-red-600 text-sm mt-1">{errors.traceCode}</p>
          )}
        </div>
        {/* Next Button */}
        <button
          onClick={handleNext}
          className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-2 px-4 rounded-xl transition duration-200"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Home;
